import { createContext, useContext, useEffect, useState } from "react";
import { pt } from "./pt";
import { de } from "./de";
import { fr } from "./fr";
import { it } from "./it";
import { en } from "./en";

const TRANSLATIONS = { pt, de, fr, it, en };
export const LANGS = ["pt", "de", "fr", "it", "en"];

const LanguageContext = createContext({ lang: "pt", setLang: () => {}, t: pt });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        const urlLang = new URLSearchParams(window.location.search).get("lang");
        if (TRANSLATIONS[urlLang]) return urlLang;
        const saved = localStorage.getItem("fam_lang");
        return TRANSLATIONS[saved] ? saved : "pt";
    });

    useEffect(() => {
        document.documentElement.lang = lang;
        localStorage.setItem("fam_lang", lang);
        const url = new URL(window.location.href);
        if (url.searchParams.get("lang") !== lang) {
            url.searchParams.set("lang", lang);
            window.history.replaceState(null, "", url);
        }
    }, [lang]);

    const setLang = (l) => {
        if (!TRANSLATIONS[l]) return;
        localStorage.setItem("fam_lang", l);
        setLangState(l);
    };

    return (
        <LanguageContext.Provider value={{ lang, setLang, t: TRANSLATIONS[lang] }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
